
const state = {
  show: false,
  bannerInfo: {}
}

const actions = {
  updateBanner (ctx, item) {
    ctx.commit('updateBanner', item)
  }
}

const mutations = {
  updateBanner (state, item) {
    state.bannerInfo = item
  },
  showAddBanner (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
